export const DRAWER_WIDTH = 275;
export const CONTENT_PADDING = 16;

// On very small screens
export const DRAWER_COLLAPSED_WIDTH_SM = 56;
export const DRAWER_HEADER_HEIGHT_SM = 56;

// For normal screens
export const DRAWER_COLLAPSED_WIDTH_LG = 65;
export const DRAWER_HEADER_HEIGHT_LG = 64;

/**
 * 100vw: Entire window width
 * - DRAWER_WIDTH: Width of the drawer when expanded
 * - CONTENT_PADDING * 2: Padding on both sides of the content
 * - 1px: Border of menu drawer
 * - 15px: Margin for possible scrollbar
 */
export const CONTENT_COLLAPSED_WIDTH = `calc(100vw - ${DRAWER_COLLAPSED_WIDTH_LG + 2 * CONTENT_PADDING + 1 + 15}px)`;

export const CONTENT_EXPANDED_WIDTH = `calc(100vw - ${DRAWER_WIDTH + 2 * CONTENT_PADDING + 1 + 15}px)`;
